module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"total_count_alert":"総数アラート","increase_count_alert":"増加数アラート"},"en":{"total_count_alert":"Total Count Alert","increase_count_alert":"Increase Count Alert"}}')
  delete Component.options._Ctor
}
